export default __webpack_public_path__ + "static/media/play.ff541a5f.svg";